import { AbstractControl, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';
import { constants } from 'src/app/config/constants';
import { DateModel } from 'src/app/models/inputs/date-model';

// export const daysOfMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
export class DateValidator {

  /**
   * format {day: number, month: number, year: number} : string
   */
  static validDateModel(lang?): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == null
        || control.value.year == null || control.value.year === ''
        || control.value.month == null || control.value.month === ''
        || control.value.day == null || control.value.day === '') {
        return (null);
      }

      const date: DateModel = control.value;
      return DateValidator.validDate(date.day + '/' + date.month + '/' + date.year, lang);
    };
  }

  static requiredDateModel(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == null
        || control.value.year == null || control.value.year === ''
        || control.value.month == null || control.value.month === ''
        || control.value.day == null || control.value.day === '') {
        return { required: true };
      }
      return (null);
    };
  }

  /**
   * format dd/mm/yyyy : string
   */
  static validDateString(lang?): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == null || control.value === '' || typeof control.value === 'undefined') {
        return (null);
      }

      return DateValidator.validDate(control.value, lang);
    };
  }

  static validBirthday(lang): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value == null || control.value === '' || typeof control.value === 'undefined'
        || control.value.year == null || control.value.year === ''
        || control.value.month == null || control.value.month === ''
        || control.value.day == null || control.value.day === '') {
        return (null);
      }

      let value;
      if (typeof control.value === 'string') {
        value = control.value;
      } else if (typeof control.value === 'object') {
        value = control.value.day + '/' + control.value.month + '/' + control.value.year;
      }

      lang = lang ? lang : constants.language;
      const [day, month, year] = value ? value.split('/') : [0, 0, 0];
      value = `${day}/${month}/${lang === 'th' ? year - 543 : year}`;
      const dateValid = DateValidator.validDate(value, lang);
      if (dateValid) {
        return dateValid;
      }
      const birthday = moment(value, 'DD/MM/YYYY', lang, true).startOf('day');
      const now = moment().startOf('day');
      if (birthday.isAfter(now)) {
        return { birthday: true };
      }
      return (null);
    };
  }
   /**
   * Validates a DateModel for leap year and general date correctness.
   * This method uses moment.js with Thai locale support.
   */
static validateLeapYear(lang?): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const value: DateModel = control.value;

    if (!value || !value.year || !value.month || !value.day) {
      return null; 
    }

    lang = lang || constants.language;

    const year = Number(value.year);
    const month = Number(value.month);
    const day = Number(value.day);

    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return { date: true }; 
    }

    const gregorianYear = (() => {
      if(lang == 'th') {
        return Number(value.year) - 543
      } else {
        return Number(value.year)
      }
    })();

    const date = moment(`${day}-${month}-${gregorianYear}`, "DD-MM-YYYY")
  

    if (!date.isValid()) {
      return { date: true }; 
    }

    return null; 
  };
}
  /**
   * format dd/mm/yyyy : string
   */
  static validDate(value, lang?): { [key: string]: boolean } | null {
    const val = moment(value, 'DD/MM/YYYY', lang ? lang : constants.language, true);

    if (!val.isValid()) {
      return ({ date: true });
    }
    return (null);
  }
}
